import { useLocation } from '@tanstack/react-router';
import { LogOut, User } from 'lucide-react';
import { SidebarTrigger } from '../ui/sidebar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { Button } from '../ui/button';
import { Avatar, AvatarFallback } from '../ui/avatar';
import { useUser, useLogout } from '../../lib/auth/hooks';

const SEGMENT_LABELS: Record<string, string> = {
  dashboard: 'Panel',
  admin: 'Yönetim',
  customers: 'Müşteriler',
  credentials: 'Kimlik Bilgileri',
  payments: 'Ödemeler',
  usage: 'Kullanım',
  audit: 'Denetim Kaydı',
};

function buildBreadcrumb(pathname: string): { label: string; href: string }[] {
  const parts = pathname.split('/').filter(Boolean);
  return parts.map((seg, i) => ({
    label: SEGMENT_LABELS[seg] ?? seg,
    href: '/' + parts.slice(0, i + 1).join('/'),
  }));
}

export function AppTopbar() {
  const { data: user } = useUser();
  const logout = useLogout();
  const location = useLocation();
  const crumbs = buildBreadcrumb(location.pathname);

  return (
    <header className="sticky top-0 z-30 flex h-14 shrink-0 items-center gap-3 border-b border-slate-200 bg-white px-4">
      <SidebarTrigger />
      <nav className="flex items-center gap-1 text-sm text-slate-500">
        {crumbs.map((c, i) => (
          <span key={c.href} className="flex items-center gap-1">
            {i > 0 && <span className="text-slate-300">/</span>}
            <span className={i === crumbs.length - 1 ? 'font-medium text-slate-900' : ''}>{c.label}</span>
          </span>
        ))}
      </nav>
      <div className="ml-auto">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="gap-2 px-2">
              <Avatar className="h-7 w-7">
                <AvatarFallback>{user?.email?.[0]?.toUpperCase() ?? '?'}</AvatarFallback>
              </Avatar>
              <span className="hidden text-sm sm:inline">{user?.email}</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            <DropdownMenuLabel>{user?.email}</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem disabled>
              <User className="h-4 w-4" />
              Profil (yakında)
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onSelect={() => logout.mutate()}>
              <LogOut className="h-4 w-4" />
              Çıkış Yap
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
